import { render, staticRenderFns } from "./page-button.vue?vue&type=template&id=ed6b31f6&scoped=true"
import script from "./page-button.vue?vue&type=script&lang=ts"
export * from "./page-button.vue?vue&type=script&lang=ts"
import style0 from "./page-button.vue?vue&type=style&index=0&id=ed6b31f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6b31f6",
  null
  
)

export default component.exports